import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'

import App from './App'
import { ErrorBoundary } from './app/ErrorBoundary'
import { queryClient } from './app/queryClient'
import { store } from './app/store'
import { initSentry, reportError } from './services/sentry'
import { startWebVitals } from './services/web-vitals'
import { installLatinDigitsInput } from './utils/latinDigits'

import './i18n'
import './index.css'
import './styles/studio.css'

// المظهر قبل أول رسم — بلا وميض الثيم الآخر لحظة الفتح
try {
  const root = document.documentElement
  root.setAttribute('data-theme', localStorage.getItem('ufuqerp_theme') || 'light')
  root.setAttribute(
    'data-style',
    localStorage.getItem('ufuqerp_style') === 'studio' ? 'studio' : 'classic',
  )
} catch {
  /* تخزين محجوب — يبقى الكلاسيكي */
}

initSentry()
startWebVitals()
// أرقامٌ عربية تُكتب بأي حقل في النظام تتحوّل إنجليزية لحظة الكتابة (هاتف، بحث، مبلغ…)
installLatinDigitsInput()

// بعد كل نشر تتغيّر أسماء ملفات الـ chunks المُهشّمة؛ تبويب مفتوح من قبل النشر
// سيفشل بتحميلها (Failed to fetch dynamically imported module).
// نعيد تحميل الصفحة مرة واحدة تلقائياً لجلب النسخة الجديدة — بحارس ضد الحلقات.
window.addEventListener('vite:preloadError', (event) => {
  const KEY = 'ufuq_chunk_reload_at'
  const last = Number(sessionStorage.getItem(KEY) ?? 0)
  if (Date.now() - last > 30_000) {
    sessionStorage.setItem(KEY, String(Date.now()))
    event.preventDefault()
    window.location.reload()
  }
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary onError={(err) => reportError(err)}>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <App />
        </Provider>
        {import.meta.env.DEV ? <ReactQueryDevtools initialIsOpen={false} /> : null}
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
)
